/**
 * ComparisonBar — GA "All Users / audience" selector for the Analytics toolbar
 * (FEAT-ANALYTICS-002). Picking a saved audience scopes every report to it.
 */
import React from 'react';
import { Menu, MenuButton, MenuList, MenuItem, MenuDivider, Button, Box, HStack, Text, Badge } from '@chakra-ui/react';
import { FiUsers, FiPlus, FiChevronDown } from 'react-icons/fi';

export function ComparisonBar({ audiences = [], filter, onFilter, onNew }) {
  return (
    <Menu>
      <MenuButton as={Button} size="sm" variant="outline" bg="white" rightIcon={<FiChevronDown />}>
        <HStack spacing={2}>
          {filter ? <Box w="8px" h="8px" borderRadius="full" bg={filter.color || 'var(--brand-primary)'} /> : <FiUsers />}
          <Text fontSize="sm">{filter ? filter.name : 'All users'}</Text>
        </HStack>
      </MenuButton>
      <MenuList maxH="360px" overflowY="auto">
        <MenuItem onClick={() => onFilter(null)} fontWeight={filter ? '400' : '700'}>
          <HStack><FiUsers /><Text>All users</Text></HStack>
        </MenuItem>
        {audiences.length > 0 && <MenuDivider />}
        {audiences.map((a) => (
          <MenuItem key={a.id} onClick={() => onFilter(a)}>
            <HStack justify="space-between" w="100%">
              <HStack><Box w="8px" h="8px" borderRadius="full" bg={a.color || 'var(--brand-primary)'} /><Text>{a.name}</Text></HStack>
              {a.size != null && <Badge colorScheme="gray" fontSize="10px">{Number(a.size).toLocaleString()}</Badge>}
            </HStack>
          </MenuItem>
        ))}
        <MenuDivider />
        <MenuItem icon={<FiPlus />} onClick={onNew}>New audience…</MenuItem>
      </MenuList>
    </Menu>
  );
}

export default ComparisonBar;
